const SHOW = 'SHOW';
const HIDE = 'HIDE';
const CALLBACK = 'CALLBACK';

const state = {
    content: {},
    width: 460,
    show: false,
    resolve: null
};

const actions = {
    /**
     * Show prompt window.
     * @param {function} commit
     * @param {object} data
     * @returns {Promise<any>}
     */
    async show({ commit }, data = {}) {
        commit(SHOW, data);

        return new Promise(resolve => {
            commit(CALLBACK, resolve);
        });
    },

    /**
     * Hide prompt window.
     * @param {function} commit
     */
    hide({ commit }) {
        commit(HIDE);
    },

    /**
     * Confirm prompt.
     * @param {function} commit
     * @param {object} state
     */
    confirm({ commit, state }) {
        state.resolve(true);
        commit(HIDE);
    },

    /**
     * Reject prompt.
     * @param {function} commit
     */
    reject({ commit }) {
        state.resolve(false);
        commit(HIDE);
    }
};

const mutations = {
    [SHOW](state, data) {
        state.show = true;

        state.width = data.width ? data.width : 460;

        state.content = data;
    },
    [HIDE](state) {
        state.show = false;
    },
    [CALLBACK](state, resolve) {
        state.resolve = resolve;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
